import React, { Fragment } from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function ProblemSection() {
  return <Section background="ivory" className="border-t border-purple-200" data-id="element-237">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-start" data-id="element-238">
        <div className="lg:sticky lg:top-32" data-id="element-239">
          <FadeIn data-id="element-240">
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif text-charcoal leading-tight mb-6" data-id="element-241">
              Wellness Shouldn't Be{' '}
              <span className="italic text-charcoal/60" data-id="element-242">Fragmented</span>
            </h2>
            <p className="text-lg text-charcoal/70 leading-relaxed max-w-md" data-id="element-243">
              Women today navigate a disjointed and often inaccessible wellness
              system — one that lacks personalization, trust, and continuity of
              care. This is not just inefficiency — it's a systemic failure in
              how women experience care.
            </p>
          </FadeIn>
        </div>

        <div className="space-y-12" data-id="element-244">
          <FadeIn delay={200} data-id="element-245">
            <div className="pl-6 border-l border-purple-300/50" data-id="element-246">
              <div className="text-5xl md:text-6xl font-serif text-charcoal mb-2" data-id="element-247">
                16<span className="text-purple-700" data-id="element-248">+</span>
              </div>
              <div className="text-sm uppercase tracking-widest text-charcoal/50 font-medium mb-2" data-id="element-249">
                Weeks
              </div>
              <p className="text-lg text-charcoal/80" data-id="element-250">
                Wait times for specialized services in Canada, leaving critical
                needs unmet.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={400} data-id="element-251">
            <div className="pl-6 border-l border-purple-300/50" data-id="element-252">
              <div className="text-5xl md:text-6xl font-serif text-charcoal mb-2" data-id="element-253">
                98<span className="text-purple-700" data-id="element-254">%</span>
              </div>
              <div className="text-sm uppercase tracking-widest text-charcoal/50 font-medium mb-2" data-id="element-255">
                Misdiagnosis
              </div>
              <p className="text-lg text-charcoal/80" data-id="element-256">
                Rates in certain psychiatric conditions, highlighting a lack of
                tailored clinical understanding.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={600} data-id="element-257">
            <div className="pl-6 border-l border-purple-300/40" data-id="element-258">
              <div className="text-3xl md:text-4xl font-serif text-charcoal mb-2" data-id="element-259">
                Majority
              </div>
              <div className="text-sm uppercase tracking-widest text-charcoal/50 font-medium mb-2" data-id="element-260">
                Underserved
              </div>
              <p className="text-lg text-charcoal/80" data-id="element-261">
                Of women with mood disorders remain without adequate, continuous
                support.
              </p>
            </div>
          </FadeIn>
        </div>
      </div>
    </Section>;
}